import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout/layout"
import SEO from "../components/layout/seo"
import MainComponent from "../components/main"

const IndexPage = () => (
  <Layout>
    <SEO title="Jakub Zboina - Architekt platformy AI" />
    <MainComponent />
  </Layout>
)

export default IndexPage
